import vipEmpFS from '../entities/vipEmpFS'
import ContactsInteractor from './contacts-interactor'

class vipEmpFSInterator extends ContactsInteractor {
  /**
   * 获取员工附属人列表
   */
  static async getVipEmpFSList(query) {
    try {
      query.clkFlag = 1
      const { data: vipEmpFSData = {} } = await super.getContactsList(query)
      if (!vipEmpFSData.list) vipEmpFSData.list = []

      return {
        data: vipEmpFSData.list.map(contacts => new vipEmpFS(contacts))
      }
    } catch (error) {
      throw error
    }
  }

}

export default vipEmpFSInterator

